import React, { type FC, type JSX } from 'react';
import Table from '@mui/material/Table';
import { type ISortsDefinition, type ColumnDefinition } from './interfaces';
import clsx from 'clsx';
import { MaterialTableBody } from './MaterialTableBody';
import { MaterialTableHeader } from './MaterialTableHeader';

interface IMaterialTableProps {
    className?: string,
    columns: ColumnDefinition[],
    data: any[] | undefined,
    dataLoading?: boolean,
    sorts?: ISortsDefinition,
    emptyStateMessage?: string | JSX.Element,
    onSortsChange?: (sorts: ISortsDefinition) => void,
    collapsible?: boolean,
    showCollapsibleHeader?: boolean,
    collapsibleRowTemplate?: (data: any) => JSX.Element,
    rowKey?: string
}

export const MaterialTable: FC<IMaterialTableProps> = (props) => {
    const { className, ...other } = props;

    return (
        <Table className={clsx("table", className)}>
            <MaterialTableHeader {...other}/>
            <MaterialTableBody {...other}/>
        </Table>
    )
}
